export enum EContractProfile {
  Courier = "Courier",

  RestaurantOwner = "RestaurantOwner",

  Customer = "Customer",
}
